import Modal from 'react-modal';
import { X } from 'react-feather';

import { modalStyles } from './styles';
import styles from './ModalGeneric.module.scss';

type ModalGenericTypes = {
  isOpen?: any;
  close?: any;
  children?: any;
  contentStyle?: any;
  closeSize?: number;
  closeColor?: string;
};

export const ModalGeneric = ({
  isOpen,
  close,
  children,
  contentStyle,
  closeSize = 16,
  closeColor = 'rgba(58, 89, 166, 0.5)',
}: ModalGenericTypes) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      style={{
        overlay: modalStyles.overlay,
        content: {
          ...modalStyles.content,
          ...contentStyle,
        },
      }}
    >
      <X
        height={closeSize}
        width={closeSize}
        color={closeColor}
        style={{
          position: 'absolute',
          right: `${closeSize === 16 ? `20px` : `-${closeSize / 2}px`}`,
          top: `${closeSize === 16 ? `20px` : `-${closeSize / 2}px`}`,
        }}
        className={styles.closeIcon}
        onClick={close}
      />
      {children}
    </Modal>
  );
};
